export default "__VITE_ASSET__R$6tYqPi__"